import React from 'react';
import NextImage from 'next/image';

import { cn } from '~/lib/utils';

export const ImageClientWithBlur = (props: {
  className?: string;
  priority?: boolean;
  src: string;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  blurDataURL?: string;
}) => {
  let alt = props.alt;
  let src = props.src;
  let width = props.width;
  let height = props.height;

  return (
    <NextImage
      alt={alt || ''}
      className={cn(props.className, 'rounded-md')}
      placeholder="blur"
      blurDataURL={
        props.blurDataURL
          ? props.blurDataURL
          : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAfklEQVR4nGM4dPz8fxA+euri/zuPXv5/+e4rGN99/Or/zfvP/p+7chuMGTiF5P7LqRr9N7f3/B+ZkPs/t7T+f23bBDAuqGz5H5Gc/9/FPwaiUF7N+L+Fg8//6MTs/4Xljf9rmnpRFHqHJf1ngFl99vItsNUgK5+9+QxmI1sNAJGOcEZrDCPtAAAAAElFTkSuQmCC'
      }
      quality={100}
      src={src}
      priority={props.priority}
      width={props.fill ? undefined : width}
      height={props.fill ? undefined : height}
      fill={props.fill}
    />
  );
};
